import { createContext } from 'react';
import { SchoolTournament } from '@/types/SchoolTournament';

type TournamentContext = {
  currentTournament: SchoolTournament | null | undefined;
  currentTournamentCategory: number | null;
};

const TournamentContext = createContext<TournamentContext>({
  currentTournament: undefined,
  currentTournamentCategory: null,
});

export default TournamentContext;
